/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = { appearances: {}, rules: [], tokens: { borderWidth: 0 } }
export default theme
